import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  return (
    <div data-testid="payment-success-page">
      <section className="bg-[#F7F4ED] section-pad">
        <div className="container-phs">
          <div className="card-default max-w-2xl mx-auto text-center">
            <CheckCircle2 className="mx-auto text-[#064E2E]" size={48}/>
            <h1 className="font-display text-3xl sm:text-4xl mt-4 text-[#071A33]">Payment Received</h1>
            <p className="mt-4 text-[#334155]">
              Thank you. Your payment has been processed by Stripe and a receipt has been emailed to you. Our records will update once Stripe confirms the webhook.
            </p>
            {sessionId && <p className="mt-4 text-xs text-[#475569]">Reference: {sessionId}</p>}
            <Link to="/" className="btn-outline mt-6 inline-flex">Back to Home</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
